import axios from 'axios';
import { API_BASE_URL } from '../../constants/api';

interface UploadResponse {
  data: {
    url: string;
    filename: string;
    size: number;
    mimetype: string;
    uploadedBy: string;
  };
  statusCode: number;
  timestamp: string;
}

class UploadService {
  async uploadImage(file: File): Promise<string> {
    const token = localStorage.getItem('accessToken');
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post<UploadResponse>(`${API_BASE_URL}/uploads/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    return response.data.data.url;
  }
}

export const uploadService = new UploadService();
